import { render, staticRenderFns } from "./bottomSoMe.vue?vue&type=template&id=5529111b&scoped=true"
import script from "./bottomSoMe.vue?vue&type=script&lang=js"
export * from "./bottomSoMe.vue?vue&type=script&lang=js"
import style0 from "./bottomSoMe.vue?vue&type=style&index=0&id=5529111b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5529111b",
  null
  
)

export default component.exports